<style lang="scss">
</style>

<template>
    <div>
        <Form :label-width="100" ref="form" :model="formData">
            <FormItem
                :label="
                    $t('fbb.warehouse.warehouse_name', {
                        defaultValue: '仓库名称',
                    })
                "
                prop="warehouseId"
                :rules="required"
            >
                <Select v-model="formData.warehouseId" filterable clearable>
                    <Option
                        v-for="item in warehousesAll"
                        :value="item.value"
                        :key="item.value"
                        >{{ item.label }}</Option
                    >
                </Select>
            </FormItem>
        </Form>
        <div class="color-error">
            1:{{
                $t("erp.virtualstore.virwarehouse_tip1", {
                    defaultValue: "若所选虚拟仓没有该仓库，则程序不做处理",
                })
            }}
        </div>
        <div class="color-error">
            2:{{
                $t("erp.virtualstore.virwarehouse_tip2", {
                    defaultValue:
                        "虚拟仓删除后，该仓库所有虚拟库存将清零，请谨慎操作！",
                })
            }}
        </div>
        <footer class="padding-top-15 text-right">
            <Button
                type="primary"
                class="width-15per margin-right-10"
                @click="submit"
                >{{
                    $t("erp.distribution.confirm_submit", {
                        defaultValue: "提交",
                    })
                }}</Button
            >
            <Button class="width-15per" @click="cancel">{{
                $t("global.common.operation_cancel", { defaultValue: "取消" })
            }}</Button>
        </footer>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
import { HttpBatchDeleteWarehouse } from "@/service/boss/allot";
import { mapState, mapGetters } from "vuex";

export default {
    props: ['ids'],
    data() {
        return {
            loading: false,
            formData: {},
            required: [
                {
                    required: true,
                    message: this.$t('global.common.required', { defaultValue: "该信息不能为空,请填写" })
                }
            ]
        };
    },
    computed: {
        ...mapGetters("diction", ["getNewWarehouseIdList"]),
        warehousesAll() {
            return this.getNewWarehouseIdList.filter(function (item) {
                return (
                    item.attach.item.warehouseType !== 2 &&
                    item.attach.item.warehouseType !== 4
                );
            });
        },
    },
    methods: {
        cancel() {
            this.$emit("on-close");
        },
        async submit() {
            let flag = true;
            await this.$refs.form.validate(valid => {
                return flag = valid;
            });
            if (!flag) return;
            this.loading = true;
            HttpBatchDeleteWarehouse({
                orgWarehouseId: this.formData.warehouseId,
                ids: this.ids
            }).then(
                (res) => {
                    this.$Message.success(res.message);
                    this.cancel();
                    this.$emit("on-update");
                    this.loading = false;
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                    this.loading = false;
                }
            );
        },
    },
};
</script>

